import { sharedEn } from '@cold-ambulance/ui';

const en = {
  ...sharedEn,
  common: {
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    next: 'Next',
    back: 'Back',
    email: 'Email',
    password: 'Password',
    confirm: 'Confirm',
    send: 'Send',
    processing: 'Processing',
    loading: 'Loading',
    error: 'Error',
    viewAll: 'View All',
    signIn: 'Sign In',
    viewDetails: 'View Details',
  },
  nav: {
    dashboard: 'Dashboard',
    requests: 'Requests',
    sentOffers: 'Sent Offers',
    payments: 'Payments',
    profile: 'Profile',
  },
  header: {
    welcome: 'Welcome',
    profileData: 'Profile Data',
    logout: 'Logout',
    notifications: 'Notifications',
    noNotifications: 'No new notifications',
    companyLogo: 'Company Logo',
  },
  home: {
    inProgressRequests: 'In-Progress Requests',
    currentTasks: 'Tasks you are currently working on',
    latestRequests: 'Latest Requests',
    noCurrentRequests: 'No current requests',
    noRequestsReceived: 'No requests have been received yet',
    noInProgressRequests: 'No in-progress requests currently',
    documentsRejected: 'Documents rejected - please re-upload',
    offerAwaitingDocs: 'You have an offer awaiting document upload',
    project: 'Project: {{name}}',
    reason: 'Reason: {{reason}}',
    documentsUploaded: '{{uploaded}} of {{total}} documents uploaded',
    reUpload: 'Re-upload',
    uploadDocuments: 'Upload Documents',
    defaultProject: 'Project',
  },
  signin: {
    title: 'Sign in as a Service Provider',
    noAccount: "Don't have an account yet?",
    registerWithUs: 'Register with us',
    forgotPassword: 'Forgot password?',
    signingIn: 'Signing in...',
  },
  signup: {
    registerWithUs: 'Register with us',
    haveAccount: 'Have an account?',
    stepTitle: 'Detailed Information',
    creatingAccount: 'Creating account...',
    continuing: 'Continuing...',
    contactPerson: 'Contact Person',
    requiredDocuments: 'Required Documents',
    phoneInUse: 'Phone number is already in use.',
    confirmPassword: 'Confirm Password',
    termsAccept: 'I agree to the terms and conditions',
    termsAcceptPrefix: 'I agree to the',
    termsAnd: 'and the',
    privacyPolicy: 'Usage and Privacy Policy',
    vendorAgreement: 'Service Provider Subscription Agreement',
  },
  profile: {
    title: 'Profile Data',
    generalInfo: 'General Information',
    contactInfo: 'Contact Information',
    requiredDocs: 'Required Documents',
    serviceProviderName: 'Service Provider Name',
    phoneNumber: 'Phone Number',
    firstName: 'First Name',
    lastName: 'Last Name',
    contactJobTitle: 'Contact Person Job Title',
    bankCertificate: 'Bank Certificate',
    commercialRegistration: 'Commercial Registration',
    taxCertificate: 'Tax Certificate',
    zakatCertificate: 'Zakat and Tax Authority Registration Certificate',
    companyLogo: 'Company Logo',
    redCrescentCertificate: 'Red Crescent Compliance Certificate',
    nationalAddressCertificate: 'National Address Certificate',
  },
  placeholders: {
    companyName: 'Medical Pioneers Company',
    firstName: 'Mashari',
    lastName: 'Al-Anzi',
    projectManager: 'Project Manager',
    enterFullName: 'Enter your full name',
    executiveDirector: 'e.g., Executive Director',
    writeRejectionReason: 'Write the reason for rejecting the transfer...',
  },
  requests: {
    allRequests: 'All Requests',
    requestDetails: 'Request Details',
    inProgress: 'In Progress: {{name}}',
    proposalDeadline: 'Proposal Deadline: {{date}}',
    bankGuarantee: 'Guarantee {{percent}}%',
  },
  services: {
    ambulance: 'Ambulance',
    equipment: 'Equipment',
    paramedic: 'Paramedic',
    nurse: 'Nurse',
    doctor: 'Doctor',
    paramedicSpecialist: 'Paramedic - Specialist',
    paramedicTechnician: 'Paramedic - Technician',
    nurseSpecialist: 'Nurse - Specialist',
    nurseTechnician: 'Nurse - Technician',
    doctorWithSpec: 'Doctor - {{specialization}}',
    ambulanceWithDriver: 'Ambulance with Driver - {{type}}',
    ambulanceWithoutDriver: 'Ambulance without Driver - {{type}}',
    ambulance4x4WithDriver: '4x4 Ambulance with Driver',
    ambulance4x4WithoutDriver: '4x4 Ambulance without Driver',
    mobileClinic: 'Mobile Clinic',
    mobileClinicBasic: 'Basic Mobile Clinic',
    mobileClinicAdvanced: 'Advanced Mobile Clinic',
    specialist: 'Specialist',
    technician: 'Technician',
  },
  offers: {
    sentOffers: 'Sent Offers',
    statusLabel: 'Status: {{status}}',
    all: 'All',
    accepted: 'Accepted',
    rejected: 'Rejected',
    pending: 'Under Discussion',
    inProgress: 'In Progress',
    notSelected: 'Not Selected',
    canceled: 'Canceled',
    filterResults: 'Filter Results',
    offeredPrice: 'Offered Price',
    status: 'Status',
    submittedOn: 'Offer submitted on',
    submitOffer: 'Submit Offer',
    submittingOffer: 'Submitting...',
    submitOfferBtn: 'Submit Offer',
    service: 'Service',
    quantity: 'Quantity',
    unitPrice: 'Unit Price / Per Hour',
    total: 'Total',
    grandTotal: 'Grand Total ({{days}} days × {{hours}} hours)',
    platformFees: '10% platform usage fee and 15% VAT will be added',
    additionalNotes: 'Additional Notes',
    optional: '(Optional)',
    charCount: '{{count}}/1000 characters',
    bankGuaranteeAck:
      'I acknowledge that if selected, I will be required to provide a bank guarantee of {{percent}}% within 10 days',
    successTitle: 'Offer submitted successfully!',
    successMessage:
      'You will receive a notification when the requesting party accepts via the notification system.',
    goToDashboard: 'Go to Dashboard',
    viewOtherRequests: 'View Other Requests',
    backToOffers: 'Back to Offers',
  },
  documents: {
    uploadRequired: 'Upload Required Documents',
    uploadedCount: 'Documents Uploaded: {{uploaded}} of {{total}}',
    uploadComplete: 'Upload Complete',
    remaining: '{{count}} remaining',
    errorLoading: 'An error occurred while loading data',
    allUploaded: 'All documents uploaded',
    allUploadedMessage:
      'Documents are now awaiting management review. You will be notified upon approval or if there are any notes.',
    approved: 'Approved',
    underReview: 'Under Review',
    rejected: 'Rejected',
    rejectionReason: 'Rejection Reason',
    documentUploaded: 'Document uploaded',
  },
  contract: {
    contractStatus: 'Contract Status',
    downloading: 'Downloading...',
    vendorSignature: 'Vendor Signature',
    customerSignature: 'Customer Signature',
    contractSigned: 'Contract signed successfully',
    contractSignedMessage:
      'The contract has been signed by both parties. The contract is now in effect.',
    awaitPayment: 'Please await payment confirmation from the customer before',
    awaitingCustomerSignature: 'Awaiting Customer Signature',
    awaitingCustomerMessage:
      'You have successfully signed the contract. We are awaiting the customer signature to complete the process.',
    vendorTransfer: 'Vendor Transfer (10%)',
    statusLabel: 'Status:',
    viewTransfer: 'View Transfer',
    approve: 'Approve',
    reject: 'Reject',
    approving: 'Approving...',
    uploading: 'Uploading...',
    submitRejection: 'Submit Rejection',
    submitting: 'Submitting...',
    transferApproved: 'Transfer approved successfully',
  },
  forgotPassword: {
    title: 'Forgot your password?',
    subtitle: 'Enter your email to reset your password.',
    emailSentTitle: 'Operation completed successfully',
    emailSentMessage: 'We have sent a password reset link to your email.',
    setNewPassword: 'Set New Password',
    setNewPasswordSubtitle:
      'Please enter your new password to update your account.',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    passwordChanged:
      'Password changed successfully, redirecting to sign in page...',
    passwordChangedTitle: 'Password changed successfully!',
    useNewPassword: 'You can use your new password.',
    errorOccurred: 'An error occurred',
    invalidCode: 'Verification code is invalid or expired',
    backToRecovery: 'Back to password recovery',
    errorChangingPassword: 'An error occurred while changing the password',
  },
  validation: {
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email address',
    passwordRequired: 'Password is required',
    passwordMin8: 'Password must be at least 8 characters',
    confirmPasswordRequired: 'Please confirm the password',
    passwordsMismatch: 'Passwords do not match',
    serviceProviderNameRequired: 'Service provider name is required',
    phoneRequired: 'Phone number is required',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    jobTitleRequired: 'Job title is required',
    contactNameRequired: 'Contact person name is required',
    contactLastNameRequired: 'Contact person last name is required',
    fileSizeLimit: 'Each file must be 10 MB or less.',
    pricePositive: 'Price must be greater than zero',
    allPricesRequired: 'Please enter a valid price for all services',
    bankGuaranteeRequired:
      'You must agree to the bank guarantee terms to proceed',
    nameRequired: 'Name is required',
    rejectionReasonRequired: 'Rejection reason is required',
  },
  errors: {
    resetLinkNotFound: 'Password reset link not found',
    verificationCodeNotFound: 'Verification code not found in the link',
    verificationCodeInvalid: 'Verification code is invalid or expired',
    unauthorized: 'You are not authorized to perform this action',
  },
} as const;

export default en;
